import { Attachment } from '../common/attachment/Attachment.interface';
import { Group } from '../secure-portal/groups/Group.interface';

export const roles = [
  { name: 'Signup', label: 'Trial Onboarding' },
  { name: 'Admin', label: 'Admin' },
  { name: 'Trainee', label: 'Trainee' },
  { name: 'DocumentAdmin', label: 'Document Admin' },
  { name: 'DocumentEditor', label: 'Document Editor' },
  { name: 'DocumentViewer', label: 'Document Viewer' },
  { name: 'DocumentHistoryViewer', label: 'Document History Access' },
  { name: 'SiteAdmin', label: 'Site Admin' },
  { name: 'TrainingAdmin', label: 'Training Admin' },
  { name: 'RiskAdmin', label: 'Risk Access' },
  { name: 'ProductAdmin', label: 'Product Access' },
  { name: 'HazardAdmin', label: 'Hazard Access' },
  { name: 'CapaAdmin', label: 'CAPA Access' },
  { name: 'ScarAdmin', label: 'SCAR Access' },
  { name: 'ChangeOrderAdmin', label: 'Change Order Access' },
  { name: 'SupplierAdmin', label: 'Supplier Access' },
  { name: 'WorkflowAdmin', label: 'Workflow Admin' },
  { name: 'Delete', label: 'Delete Permission' }
];

export interface Role {
  id?: number;
  name?: string;
}

export interface User {
  id: number;
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  verified?: boolean;
  readonly deleted?: boolean;
  readonly created?: Date;
  readonly createdBy?: number;
  readonly modified?: Date;
  readonly modifiedBy?: number;
  roles?: Role[];
  groups?: Group[];
  isPasswordSet?: boolean;
  compliance?: 'compliant' | 'in-progress' | 'non-compliant';
  attachments?: Attachment[];
}

export interface ResetPassword {
  password: string;
  token: string;
}

export interface VerifyEmail {
  token: string;
}

export interface UserTrainingUpcoming {
  trainingId: number;
  trainingVersionId: number;
  trainingName: string;
  trainingDeadline: Date;
}

export interface TrainingStats {
  userId: number;
  toDoCount: number;
  inProgressCount: number;
  completedCount: number;
}

export interface UserStat {
  id: string;
  label: string;
  value: number;
}

export interface UserStats {
  totalUsers: number;
  stats: UserStat[];
}

export interface UserRegisterDto {
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  password: string;
}

export interface UserPermissionFilter {
  groupIds?: number[];
  roles?: string[];
}

export interface UserSummary {
  active: number;
  total: number;
}
